import { isString } from "lodash";
import { HTMLProps, ReactNode, useMemo } from "react";
import cn from "clsx";

type FooterType = HTMLProps<HTMLDivElement> & {
  description?: ReactNode;
  descriptionPosition?: "left" | "right";
  className?: string;
};
export const Footer = ({ description, descriptionPosition = "left", className, children }: FooterType) => {
  const title = isString(children) ? children : "";

  const descriptionComponent = useMemo(() => description && <div className="">{description}</div>, [description]);

  return (
    <div className={cn("flex gap-1 text-xs overflow-hidden", className)}>
      {descriptionPosition === "left" ? descriptionComponent : undefined}
      <div className="flex items-center overflow-hidden cursor-default text-text-base-secondary-a" title={title}>
        <span className="block truncate">{children}</span>
      </div>
      {descriptionPosition === "right" ? descriptionComponent : undefined}
    </div>
  );
};
